module.exports = __webpack_public_path__ + "media/images/background-cover-default-d159fa42328ca75b3a585f77482fc586.png";